<template>
    <project-step-container
        cover-page
        prev-to="be_go_broad_to_go_narrow_16"
        :on-discard-project="redirection"
        :on-keep-version-project="redirection"
        @next-click="updateProject">
        <div class="content-cover">
            <div class="content-cover-item first-form-initial-3">
                <div class="content-cover-item-header">
                    <div class="rapid-icon"/>
                </div>
                <div class="content-cover-item-body">
                    <p class="content-cover-item-body-title cover-body-title-3 text-uppercase " tabindex="0"> {{getMessage(17, 'rapidexperiment-title')}} </p>
                    <p class="content-cover-item-body-description cover-body-title-3" tabindex="0">
                       {{getMessage(17, 'rapidexperiment-sub')}}
                    </p>
                </div>
                <div class="content-cover-item-footer circles-icon"></div>
            </div>
            <div class="content-cover-item content-guide">
                <LinkStyleGuide class="guide-text guide-padding" :is-box-shadow="false" @open-url="openGuide"
                                icon-name="icon-guide"
                                :text="getMessage(17, 'rapidexperiment-guide')"/>
            </div>
        </div>
        <project-style-guide :style-guide="styleGuide"/>
    </project-step-container>
</template>

<script>
import ProjectStepContainer from "../../../core/Components/ProjectStepContainer"
import LinkStyleGuide from "../../../core/Components/LinkStyleGuide";
import ProjectStyleGuide from "../../../core/Components/ProjectStyleGuide";
import {ConflictSyn, Project, StyleGuides} from "../../../core/Utils";
import {Steps} from "@/modules/BeEntrepreneurship/Utils";

export default {
    name: "RapidExperimentsWithCustomers17",
    components: {ProjectStepContainer, LinkStyleGuide, ProjectStyleGuide},
    data() {
        return {
            step: Steps.FORM_RAPID_EXPERIMENTS,
            styleGuide: StyleGuides.getStyleGuide(StyleGuides.RAPID_EXPERIMENTS)
        }
    },
    methods: {
        openGuide() {
            this.$bvModal.show('project-style-guide')
        },
        updateProject() {
            const stepNumber = Steps.getStepFromForm(this.step)
            const index = this.$route.params.index

            Project.saveProjectStep(index, this.step, stepNumber, {}, this.isOffline, this.isGuest).then(response => {
                if (response.project?.hasDifferenceVersion) {
                    ConflictSyn.show(response.index, response.project)
                } else {
                    this.redirection()
                }
            }).catch(err => {
                this.redirection()
            })
        },
        redirection() {
            const index = this.$route.params.index
            this.$router.push({name: 'be_rapid_experiments_with_customers_18', params: {index}})
        }
    }
}
</script>

<style lang="stylus" scoped>
    @import "~@/core/Styles/variables.styl"
    @import "~@/core/Styles/mixins.styl"

    .font-size
        .content-cover
           padding-bottom: 25px;
    .content-cover-item-body
        margin-top -30px
    .subtitle
        font font-sourcesans-bold
        font-size 20px

    .rapid-icon
        background url("../../D4D/Images/rapid-icon.svg")
        height 89px
        width 183px
        background-repeat no-repeat

    .circles-icon
        background url("../../D4D/Images/circles.svg")
        height 58px
        width 100%
        border-radius 0 0 27px 27px;
        opacity 0.5

    .guide-icon
        margin-top -20px
</style>
